/**
 * Possible progress indicator types.
 */
export enum IndicatorVariant {
    DOTS = 'dots',
    TEXT = 'text',
    PROGRESS = 'progress'
}
